/**
 * Get Product Sales Report Use Case
 *
 * Business logic for fetching product sales report
 */

import {ProductSalesReportRepository} from '../repository/ProductSalesReportRepository';
import {
  ProductSalesReportData,
  ProductSalesReportFilters
} from '../models/productSalesReport.model';

export class GetProductSalesReportUseCase {
  constructor(private productSalesReportRepository: ProductSalesReportRepository) {}

  async execute(filters?: ProductSalesReportFilters): Promise<ProductSalesReportData> {
    try {
      // Validate date filters if provided
      if (filters?.date_from && filters?.date_to) {
        const fromDate = new Date(filters.date_from);
        const toDate = new Date(filters.date_to);

        if (fromDate > toDate) {
          throw new Error('تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية');
        }
      }

      return await this.productSalesReportRepository.getProductSalesReport(filters);
    } catch (error) {
      throw new Error(
        `Failed to get product sales report: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`
      );
    }
  }
}

